module.exports = __webpack_public_path__ + "static/media/content-1.99cb2fbb.png";